'use strict';
/**
 * Service for treatment API endpoints
 */
export default [
  '$resource',
  function ($resource) {
    return $resource('api/treatment/:treatmentId', null, {
      getAll: { method: 'GET' },
      get: {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Accept-Encoding': 'identity',
        },
        transformResponse: [
          function (data) {
            // Если данные уже являются объектом, возвращаем их как есть
            if (typeof data === 'object' && data !== null) {
              return data;
            }

            // Для строки пробуем парсить JSON
            if (typeof data === 'string' && data.trim()) {
              try {
                // Удаляем BOM если он есть
                let cleanData = data.replace(/^\uFEFF/, '');

                // Ищем последнюю закрывающую скобку и обрезаем всё после неё
                const lastBraceIndex = cleanData.lastIndexOf('}');
                if (lastBraceIndex !== -1) {
                  cleanData = cleanData.substring(0, lastBraceIndex + 1);
                }

                // Ищем первую открывающую скобку
                const firstBraceIndex = cleanData.indexOf('{');
                if (firstBraceIndex !== -1) {
                  cleanData = cleanData.substring(firstBraceIndex);
                }

                return JSON.parse(cleanData);
              } catch (e) {
                console.error('JSON parse error:', e);
                console.log('Data length:', data.length);
                console.log('Data preview:', data.substring(0, 100)); // показываем начало данных
                return null;
              }
            }

            return data;
          },
        ],
      },
      create: { method: 'POST' },
      update: {
        method: 'PUT',
        url: 'api/treatment/:id', // Changed from default to explicit URL
      },
      remove: { method: 'DELETE', url: 'api/treatment/:id' },
      toProject: {
        url: 'api/treatment/:id/to-project',
        method: 'POST',
      },
    });
  },
];
